import Construction from "@mui/icons-material/Construction";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { ReactElement } from "react";

import { commonLabels } from "../ui/labels/common-labels";
import { sxStyles } from "./maintenance-page-style";

export const MaintenancePage = (): ReactElement => {
  return (
    <Stack
      sx={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper sx={(theme) => sxStyles(theme).paper}>
        <Typography sx={(theme) => sxStyles(theme).title}>{commonLabels.maintenanceMode.title}</Typography>
        <Box sx={(theme) => sxStyles(theme).icon}>
          <SvgIcon fontSize="inherit">
            <Construction />
          </SvgIcon>
        </Box>
        <Typography sx={(theme) => sxStyles(theme).description}>{commonLabels.maintenanceMode.description}</Typography>
      </Paper>
    </Stack>
  );
};
